import { Head, router } from '@inertiajs/react'
import { Box, Container, Typography, ThemeProvider } from '@mui/material'
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material'
import { SecondaryButton } from '../../components'
import ProfileEdit from '../../components/prospects/ProfileEdit'
import theme from '../../styles/theme'
import { useAuth } from '../../hooks/useAuth'

interface ProfileData {
    // Basic Info
    first_name: string;
    last_initial: string;
    photo: string | null;
    profile_pic_url: string | null;
    short_intro: string;
    
    // Employment
    occupation: string;
    employer: string;
    
    // Rental Preferences
    budget: string;
    bedrooms: string;
    bathrooms: string;
    desired_move_in: string;
    lease_length: string;
    pets: string;
    occupants: string;
    neighborhoods: string;
    additionalInfo: string;
    
    // Pet and housing info
    housingVoucher: string;
    numDogs: string;
    numCats: string;
}

interface Props {
    profileData: ProfileData;
}

export default function ProfileEditPage({ profileData }: Props) {
    const { renter } = useAuth();
    
    const handleGoBack = () => {
        router.visit(`/renters/${renter?.id}/profile`)
    }

    const handleCancel = () => {
        router.visit(`/renters/${renter?.id}/profile`)
    }

    return (
        <ThemeProvider theme={theme}>
            <Head title="Edit Profile - HeyyProperty" />
            
            <Box sx={{
                minHeight: '100vh',
                bgcolor: 'grey.50',
                py: 3
            }}>
                <Container maxWidth="md">
                    {/* Header */}
                    <Box sx={{ 
                        mb: 3, 
                        display: 'flex', 
                        alignItems: 'center',
                        position: 'sticky',
                        top: 0,
                        zIndex: 1000,
                        bgcolor: 'grey.50',
                        py: 2,
                        borderBottom: '1px solid',
                        borderColor: 'grey.200'
                    }}>
                        <SecondaryButton
                            startIcon={<ArrowBackIcon />}
                            onClick={handleGoBack}
                        >
                            Back to Profile
                        </SecondaryButton>
                    </Box>
                    
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                            Edit Profile
                        </Typography>
                        <Typography variant="body1" color="grey.600">
                            Update your profile information to help landlords get to know you better.
                        </Typography>
                    </Box>

                    {/* Profile Edit Form */}
                    <ProfileEdit 
                        profileData={profileData}
                        onCancel={handleCancel}
                    />
                </Container>
            </Box>
        </ThemeProvider>
    )
}
